/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import { calculateQuote } from '../../util'
import { copyArea } from '../../areas/copy-area/copy-area'
import { copyLineItem } from '../../line-items/copy-line-item/copy-line-item'
import { copyGroup } from '../../groups/copy-group/copy-group'
import type { QuoteItemSection } from '../..'

export function copyItems(args: {
  quote: QuoteDocument
  options: OptionsDocument
  keys: string[]
  section?: QuoteItemSection
}): QuoteDocument {
  const { quote, options, keys, section } = args

  const updatedQuote = keys.reduce((accQuote: QuoteDocument, key: string) => {
    return copyItem({ quote: accQuote, options, key, calculate: false, section })
  }, quote)

  return calculateQuote({ quote: updatedQuote, options })
}

export function copyItem(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  calculate?: boolean
  useKey?: string
  section?: QuoteItemSection
}): QuoteDocument {
  const { quote, key } = args

  if (quote.areas[key]) {
    return copyArea(args)
  } else if (quote.lineItems[key]) {
    return copyLineItem(args)
  } else if (quote.groups[key]) {
    return copyGroup(args)
  } else {
    return { ...quote }
  }
}
